<template>
  <div id="ly_scenic_edit">
    <div class="page-header">
      <el-page-header @back="$router.back()" :content="isEdit ? '编辑景区' : '创建景区'" />
    </div>
    <el-form :model="form" :rules="rules" ref="scenicForm" label-width="120px" class="edit-form">
      <el-card class="form-card" header="基本信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="景区名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入景区名称" maxlength="100" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder="请输入联系电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="景区等级" prop="level">
              <el-select v-model="form.level" placeholder="请选择景区等级" style="width:100%">
                <el-option label="5A级" value="5A" />
                <el-option label="4A级" value="4A" />
                <el-option label="3A级" value="3A" />
                <el-option label="2A级" value="2A" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用城市" prop="cityCode">
              <el-cascader v-model="cityArr" :options="cityCodeJson" :props="cityProps"
                @change="onCityChange" style="width:100%" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="景区地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入详细地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开放时间" prop="openTime">
              <el-input v-model="form.openTime" placeholder="如：08:00-18:00（旺季），09:00-17:00（淡季）" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="特色标签" prop="tags">
              <el-input v-model="form.tags" placeholder="多个标签逗号分隔，如：网红打卡地,亲子游,历史文化" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <el-card class="form-card" header="景区图片">
        <el-form-item label="主图" prop="scenicImg">
          <div class="img-list">
            <div v-for="(img, idx) in imgList" :key="idx" class="img-item">
              <el-image :src="img" fit="cover" style="width:100px;height:80px;border-radius:4px" />
              <el-button type="text" class="img-del" @click="removeImg(idx)">删除</el-button>
            </div>
            <el-upload class="img-upload" action="/api/v1/upload/img" :show-file-list="false"
              :on-success="onImgUpload" accept="image/*">
              <div class="upload-btn"><i class="el-icon-plus" /></div>
            </el-upload>
          </div>
        </el-form-item>
      </el-card>

      <el-card class="form-card" header="景区介绍">
        <el-form-item label="景区描述" prop="scenicDescribe">
          <el-input v-model="form.scenicDescribe" type="textarea" :rows="6" placeholder="请输入景区描述（支持富文本）" />
        </el-form-item>
      </el-card>

      <div class="form-footer">
        <el-button @click="$router.back()">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { cityCodeJson } from "@/assets/js/city";
export default {
  name: "ly_scenic_edit",
  data() {
    return {
      cityCodeJson,
      cityArr: [],
      cityProps: { label: "name", value: "citycode", children: "districts" },
      loading: false,
      imgList: [],
      form: {
        id: null,
        name: "",
        contactPhone: "",
        level: "",
        province: "",
        city: "",
        area: "",
        cityCode: "",
        address: "",
        longitude: null,
        latitude: null,
        openTime: "",
        tags: "",
        scenicImg: "",
        scenicDescribe: "",
        status: 2,
      },
      rules: {
        name: [{ required: true, message: "请输入景区名称", trigger: "blur" }],
        address: [{ required: true, message: "请输入景区地址", trigger: "blur" }],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.query.id;
    },
  },
  created() {
    if (this.isEdit) {
      this.loadScenic();
    }
  },
  methods: {
    async loadScenic() {
      let { code, data } = await this.$axios.get(`/api/v1/manage/travelScenic/${this.$route.query.id}`);
      if (code === 1 && data) {
        Object.keys(this.form).forEach(k => { if (data[k] !== undefined) this.form[k] = data[k]; });
        if (data.scenicImg) {
          this.imgList = data.scenicImg.split(",").filter(Boolean);
        }
        if (data.cityCode) {
          this.cityArr = [data.province, data.city, data.cityCode].filter(Boolean);
        }
      }
    },
    onCityChange(val) {
      if (val && val.length > 0) {
        this.form.cityCode = val[val.length - 1];
        this.form.city = val[val.length > 1 ? val.length - 2 : 0];
        this.form.province = val[0] || "";
      }
    },
    onImgUpload(res) {
      if (res.code === 1 && res.data) {
        this.imgList.push(res.data);
        this.form.scenicImg = this.imgList.join(",");
      }
    },
    removeImg(idx) {
      this.imgList.splice(idx, 1);
      this.form.scenicImg = this.imgList.join(",");
    },
    submitForm() {
      this.$refs.scenicForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          let url = "/api/v1/manage/travelScenic";
          let { code } = this.isEdit
            ? await this.$axios.put(url, this.form)
            : await this.$axios.post(url, this.form);
          if (code === 1) {
            this.$message.success(this.isEdit ? "修改成功" : "创建成功");
            this.$router.push({ path: "/travelScenic" });
          }
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#ly_scenic_edit {
  padding: 16px;
  .page-header { margin-bottom: 16px; }
  .form-card { margin-bottom: 16px; }
  .edit-form { max-width: 900px; }
  .form-footer { text-align: center; padding: 20px 0; }
  .img-list {
    display: flex; flex-wrap: wrap; gap: 10px;
    .img-item { position: relative; display: inline-block; }
    .img-del { position: absolute; bottom: 0; left: 0; right: 0; text-align: center; background: rgba(0,0,0,.4); color: #fff; }
    .upload-btn {
      width: 100px; height: 80px; border: 1px dashed #d9d9d9; border-radius: 4px;
      display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 24px; color: #999;
      &:hover { border-color: #409EFF; color: #409EFF; }
    }
  }
}
</style>
